import ReactDOM from 'react-dom'
import React from 'react'
import { ApolloProvider } from '@apollo/client'
import client from './shared/apollo-client'
import { MainAppRoutes } from './routes/mainAppRoutes'
import { ToastContainer, Slide } from 'react-toastify'
import { FeatureListContextProvider } from './context/FeatureListContext'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './assets/scss/style.scss'
import 'react-toastify/dist/ReactToastify.css'
import 'react-phone-input-2/lib/style.css'

ReactDOM.render(
  <FeatureListContextProvider>
    <ApolloProvider client={client}>
      <ToastContainer transition={Slide} />
      <MainAppRoutes />
    </ApolloProvider>
  </FeatureListContextProvider>,

  document.getElementById('root')
)
